import React, {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import axios from "axios";

const CandidateShowComponent = (props) => {

  const {t} = props;
  const {id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    apiCall('get', '/api/v2/candidate/' + id)
      .then(response => {
        setFormData(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [id, window.App.state.rerenderCandidateShow]);

  return (
      <div className={"purchaserequest-form widget"}>
        {loading &&
          <ProgressBar mode="indeterminate"
                       style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
        }
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="location">{t('columnName2')}</label>
              <span className="p-d-block fake-input">
                {formData?.name}
              </span>
            </div>
          </div>

          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="location">{t('fieldResume')}</label>
              <span className="p-d-block fake-input">
                {formData?.has_c_v}
              </span>
            </div>
          </div>

          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="location">{t('columnEmail')}</label>
              <span className="p-d-block fake-input">
                {formData?.email}
              </span>
            </div>
          </div>

          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="created_at">{t('columnPhone')}</label>
              <span className="p-d-block fake-input">
                {formData?.phone}
              </span>
            </div>
          </div>

          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="created_by_name">{t('fieldGender')}</label>
              <span className="p-d-block fake-input">
                {formData?.gender}
              </span>
            </div>
          </div>

          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="last_name">{props.t('columnDateOfBirth')}</label>
              <span className="p-d-block fake-input">
                {formData?.birthday ? window.App.formatDateValue(formData.birthday) : ''}
              </span>
            </div>
          </div>
          <br></br>


          
          <div className={"p-col-12 p-lg-12 p-col-align-center p-text-center p-text-lg-left p-mt-3 p-mb-3"}>
            <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
              {t('addressData')}
            </h3>
          </div>
          

          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="created_at">{t('fieldResidence')}</label>
              <span className="p-d-block fake-input">
                {[formData?.country, formData?.zip, formData?.city].filter(Boolean).join(' ')}
              </span>
            </div>
          </div>

          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="note">{t('fieldHomeAddress')}</label>
              <span className="p-d-block fake-input">
                {formData?.address || formData?.home_address || ''}
              </span>
            </div>
          </div>

          <div className={"p-col-12 p-lg-12 p-col-align-center p-text-center p-text-lg-left p-mt-3 p-mb-3"}>
            <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
              {t('permissionsKnowledge')}
            </h3>
          </div>

          

          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="location">{t('fieldDriverLicenses')}</label>
              <span className="p-d-block fake-input">
                {[
                  formData?.driver_license_a ? 'A' : null,
                  formData?.driver_license_b ? 'B' : null,
                  formData?.driver_license_c ? 'C' : null,
                  formData?.driver_license_d ? 'D' : null,
                  formData?.driver_license_e ? 'E' : null,
                  formData?.driver_license_forklift ? 'Targonca' : null,
                  formData?.driver_license_logistics ? 'Logisztika' : null,
                  formData?.driver_license_agrarian ? 'Agrár' : null,
                  formData?.driver_license_none ? props.t('none') : null,
                ].filter(Boolean).join(', ')}
              </span>
            </div>
          </div>

          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="location">{t('fieldHasCar')}</label>
              <span className="p-d-block fake-input">
                {formData?.have_car}
              </span>
            </div>
          </div>



          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="last_name">{t('fieldWorkTypes')}</label>
              <span className="p-d-block fake-input">
                {''}
              </span>
            </div>
          </div>

          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="created_at">{t('fieldRegions')}</label>
              <span className="p-d-block fake-input">
                {[formData?.county].filter(Boolean).join(', ')}
              </span>
            </div>
          </div>



          <div className={"p-col-12 p-lg-12 p-col-align-center p-text-center p-text-lg-left p-mt-3 p-mb-3"}>
            <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
              {t('candidateOther')}
            </h3>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="location">{t('fieldPartTimeOnly')}</label>
              <span className="p-d-block fake-input">
                {formData?.part_time}
              </span>
            </div>
          </div>

          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="location">{t('fieldTrainee')}</label>
              <span className="p-d-block fake-input">
                {formData?.trainee}
              </span>
            </div>
          </div>

          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="location">{t('fieldStudent')}</label>
              <span className="p-d-block fake-input">
                {formData?.student}
              </span>
            </div>
          </div>

          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="location">{t('fieldGeneralRegistrationQuestion')}</label>
              <span className="p-d-block fake-input">
                {formData?.general_registration}
              </span>
            </div>
          </div>

          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="created_at">{t('fieldNewsletter')}</label>
              <span className="p-d-block fake-input">
                {formData?.newsletter}
              </span>
            </div>
          </div>
        </div>
      </div>
    )

}

export default withTranslation('common')(CandidateShowComponent);
